import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import queryString from 'query-string';
import BookingLauncher from '../BookingLauncher/BookingLauncher';
import { setExperiencesList, setExperienceSelected, setExperienceBookingModal } from '../../../actions/experiences';
import ExperiencesDataListV2 from '../Data/ExperiencesV2';
import TitleImage from '../../shs/TitleImage/TitleImage';
import { handleAdobePageAnalytics } from 'packages/smart-home-support/utils';
import analyticsContext from '../../analytics/Analytics';
import partnerStyles from '../../../config/partnerStylesConfig';

class ExperienceDetails extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    const currentMegaUsecase = this.props.experienceSelected && this.props.experienceSelected.megaUseCase;
    const prevMegaUsecase = prevProps.experienceSelected && prevProps.experienceSelected.megaUseCase;
    if (this.props.experienceSelected && prevMegaUsecase !== currentMegaUsecase) {
      analyticsContext
        .withAdvancedProps({
          section: 'experienceDetails',
          experience: currentMegaUsecase,
        })
        .screenEvent();
    }
  }
  componentDidMount() {
    handleAdobePageAnalytics();
    window.scrollTo(0, 0);
  }

  onShowBookingModal = () => {
    window.scrollTo(0, 0);
  };

  onHideBookingModal = () => {
    // Do nothing.
  };

  renderImage = () => (
    <div
      className="image"
      style={{
        backgroundImage:
          'url(' + (this.props.experienceSelected && this.props.experienceSelected.details.imageSrc) + ')',
      }}
    />
  );

  renderDetails = () => (
    <div className="details">
      <div className="title articleTitleFonts">
        {this.props.experienceSelected && this.props.experienceSelected.details.title}
      </div>
      <div className="text bodyTextFonts">
        {this.props.experienceSelected && this.props.experienceSelected.details.text}
      </div>
    </div>
  );

  render() {
    return (
      <div className="ExperienceDetailsContainer">
        {/* {this.renderImage()} */}
        {this.props.experienceSelected && partnerStyles.hasExperiencesDetailsTitleImage && (
          <TitleImage
            img={this.props.experienceSelected.details.imageSrc}
            title={this.props.experienceSelected.details.title}
          />
        )}
        {!partnerStyles.hasExperiencesDetailsTitleImage && <div style={{ height: '30px' }} />}

        <Grid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={8}>
              {this.renderDetails()}
            </Col>
            <Col xs={12} sm={12} md={12} lg={4}>
              <BookingLauncher onShowBookingModal={this.onShowBookingModal} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => ({
  experiencesList:
    state.experiences.experiencesList && state.experiences.experiencesList.version === 2
      ? state.experiences.experiencesList.data
      : null,
  experienceSelected: state.experiences.experienceSelected,
  experienceBookingModal: state.experiences.experienceBookingModal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setExperiencesList,
      setExperienceSelected,
      setExperienceBookingModal,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ExperienceDetails));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/ExperienceDetails/ExperienceDetails.js